import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const [stats, setStats] = useState({
    pendingIndividual: 0,
    pendingCorporate: 0,
    totalApprovedToday: 0,
    activeUsers: 0,
    upcomingSchedules: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem("adminToken");
      console.log(
        "Fetching stats with token:",
        token ? "Token exists" : "No token",
      );

      const response = await fetch(
        `${
          process.env.REACT_APP_API_URL || "http://localhost:3500"
        }/api/admin/stats`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Response status:", response.status);
      console.log("Response headers:", response.headers);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Error response:", errorText);
        throw new Error(
          `Failed to fetch dashboard statistics: ${response.status} - ${errorText}`,
        );
      }

      const data = await response.json();
      console.log("Stats data received:", data);
      setStats(data);
    } catch (error) {
      console.error("Error fetching stats:", error);
      setError(`Failed to load dashboard statistics: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="main-content">
        <div className="container">
          <div className="loading-spinner">Loading dashboard...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="main-content">
        <div className="container">
          <h1 className="page-title">Admin Dashboard</h1>
          <p className="page-subtitle">
            Manage candidate and corporate approvals
          </p>

          {error && <div className="error-message">{error}</div>}

          <div className="grid">
            <Link to="/approve-individual" className="action-card">
              <div className="card-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <h3>Approve Individual Candidates</h3>
              <p>
                Review and approve individual candidate profiles and
                applications
              </p>
              <div className="card-arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </div>
            </Link>

            <Link to="/approve-corporate" className="action-card">
              <div className="card-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M3 21h18"></path>
                  <path d="M3 7h18"></path>
                  <path d="M3 3h18"></path>
                  <path d="M7 21V7"></path>
                  <path d="M17 21V7"></path>
                </svg>
              </div>
              <h3>Approve Corporate</h3>
              <p>Review and approve corporate profiles and job postings</p>
              <div className="card-arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </div>
            </Link>

            <Link to="/approve-interest" className="action-card">
              <div className="card-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="10" height="14" rx="2"></rect>
                  <path d="M7 7h2"></path>
                  <path d="M7 11h2"></path>
                  <circle cx="18" cy="17" r="3"></circle>
                  <path d="M18 14v-2"></path>
                </svg>
              </div>
              <h3>Approve Candidate Interest</h3>
              <p>Review and approve candidate interest profiles</p>
              <div className="card-arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </div>
            </Link>

            <Link to="/candidate-schedules" className="action-card">
              <div className="card-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
              </div>
              <h3>View Candidate Discussion Schedules & Career Journey</h3>
              <p>
                Review upcoming candidate discussion appointments and add career
                journey
              </p>
              <div className="card-arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </div>
            </Link>

            <Link to="/approve-profile-updates" className="action-card">
              <div className="card-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h3>Approve Profile Updates</h3>
              <p>
                Review and approve profile update requests from active
                candidates
              </p>
              <div className="card-arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </div>
            </Link>
            <Link to="/active-users" className="action-card">
              <div className="card-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="m23 21-2-2"></path>
                  <path d="m16 3.13 2 2"></path>
                  <path d="m20 7-2-2"></path>
                  <path d="m10 21 2-2"></path>
                  <path d="m10 3 2 2"></path>
                  <path d="m14 7-2-2"></path>
                </svg>
              </div>
              <h3>View All Active Users</h3>
              <p>Browse and manage all active users in the system</p>
              <div className="card-arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </div>
            </Link>
          </div>

          <div className="stats-section">
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-number">{stats.pendingIndividual}</div>
                <div className="stat-label">Pending Individual Approvals</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{stats.pendingCorporate}</div>
                <div className="stat-label">Pending Corporate Approvals</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{stats.totalApprovedToday}</div>
                <div className="stat-label">Total Approved Today</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{stats.activeUsers}</div>
                <div className="stat-label">Active Users</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">{stats.upcomingSchedules}</div>
                <div className="stat-label">Upcoming Schedules</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
